import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...l }, /* @__PURE__ */ e.createElement("path", { fill: "#4D4E58", fillRule: "evenodd", d: "M5.525 4.818a.5.5 0 1 0-.707.707L7.293 8l-2.475 2.475a.5.5 0 1 0 .707.707L8 8.707l2.475 2.475a.5.5 0 0 0 .707-.707L8.707 8l2.475-2.475a.5.5 0 1 0-.707-.707L8 7.293 5.525 4.818Z", clipRule: "evenodd" }));
export {
  t as default
};
